import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';

const PlayerTags = (props) => {
    const { title } = props;
    const { globalState } = useContext(context);

    return (
        <Helmet>
            {isValidString(title) && isValidObject(globalState) && isValidObject(globalState.accountObject) && isValidString(globalState.accountObject.url) ? (
                <script type="application/ld+json">
                    {`
                        {
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Roster",
                                "item": "${globalState.accountObject.url}/roster"
                            },{
                                "@type": "ListItem",
                                "position": 2,
                                "name": "${title.replace(/['"]+/g, '')}"
                            }]
                        }
                `}
                </script>
            ) : null}
        </Helmet>
    );
};

PlayerTags.propTypes = {
    title: PropTypes.string.isRequired,
};

export default memo(PlayerTags);
